import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import AuthLayout from "@/views/Pages/AuthLayout.vue";
import NotFound from "@/views/GeneralViews/NotFoundPage.vue";

// Dashboard
const Dashboard = () => import("@/views/Dashboard/Dashboard.vue");
const Sync = () => import("@/views/Dashboard/SincronizarRestaurantes.vue");

// Clientes
const ListaClientes = () => import("@/views/Pages/Clientes/ListaClientes.vue");
const descontos = () => import("@/views/Pages/Clientes/descontos/index.vue");
const whatsapp = () => import("@/views/Pages/Whatsapp/Inbox.vue");
const ListaSegmentos = () =>
  import("@/views/Pages/Clientes/ListaSegmentos.vue");

// Campanhas
const CriarCampanhas = () =>
  import("@/views/Pages/Campanhas/CriarCampanhas.vue");
const GerirTemplates = () =>
  import("@/views/Pages/Campanhas/GerirTemplates.vue");
const HistoricoCampanhas = () =>
  import("@/views/Pages/Campanhas/HistoricoCampanhas.vue");

// Insights
const Insights = () => import("@/views/Pages/Insights/VerInsights.vue");
const Estatisticas = () => import("@/views/Pages/Insights/VerEstatisticas.vue");

// Definições
const Definicoes = () => import("@/views/Pages/Definicoes/Definicoes.vue");
const Categorias = () =>
  import("@/views/Pages/Definicoes/CategoriasProdutos.vue");

// Auth
const Login = () => import("@/views/Pages/Login.vue");
const Recuperar = () => import("@/views/Pages/RecuperarPass.vue");
const Register = () => import("@/views/Pages/Register/index.vue");

// Setup
const Setup = () => import("@/views/Pages/Setup/index.vue");

// Restaurantes
const GerirRestaurantes = () =>
  import("@/views/Pages/Restaurantes/GerirRestaurantes.vue");

// ── NOVO: Staff ───────────────────────────────────────────────────────────
const GerirStaff = () => import("@/views/Pages/Staff/GerirStaff.vue");
const AceitarConvite = () => import("@/views/Pages/Staff/AceitarConvite.vue");

let clientesMenu = {
  path: "/clientes",
  component: DashboardLayout,
  redirect: "/clientes/lista-clientes",
  name: "Clientes",
  children: [
    {
      path: "lista-clientes",
      name: "Lista Clientes",
      component: ListaClientes,
    },
    { path: "whatsapp", name: "Whatsapp", component: whatsapp },
    { path: "descontos", name: "Descontos", component: descontos },
    { path: "segmentos", name: "Segmentos", component: ListaSegmentos },
  ],
};

let campanhasMenu = {
  path: "/campanhas",
  component: DashboardLayout,
  redirect: "/campanhas/criar",
  name: "Campanhas",
  children: [
    { path: "criar", name: "Criar Campanhas", component: CriarCampanhas },
    { path: "templates", name: "Gerir Templates", component: GerirTemplates },
    {
      path: "historico",
      name: "Histórico Campanhas",
      component: HistoricoCampanhas,
    },
  ],
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    { path: "/login", name: "Login", component: Login },
    { path: "/recuperar", name: "Recuperar", component: Recuperar },
    { path: "/register", name: "Register", component: Register },
    {
      path: "/aceitar-convite",
      name: "AceitarConvite",
      component: AceitarConvite,
    }, // ← NOVO (pública, sem login)
    { path: "*", component: NotFound },
  ],
};

const routes = [
  { path: "/", redirect: "/dashboard", name: "Home" },
  clientesMenu,
  campanhasMenu,
  {
    path: "/",
    component: DashboardLayout,
    name: "Dashboard layout",
    children: [
      { path: "dashboard", name: "Dashboard", component: Dashboard },
      { path: "sync", name: "Sync", component: Sync },
      { path: "/insights", name: "Insights", component: Insights },
      {
        path: "/estatisticas",
        name: "Estatísticas Mensais",
        component: Estatisticas,
      },
      { path: "/definicoes", name: "Definicoes", component: Definicoes },
      { path: "/categorias", name: "Categorias", component: Categorias },
      { path: "/setup", name: "Setup", component: Setup },
      {
        path: "/restaurantes",
        name: "Restaurantes",
        component: GerirRestaurantes,
      },
      { path: "/staff", name: "GerirStaff", component: GerirStaff }, // ← NOVO
    ],
  },
  authPages,
];

export default routes;
